import {
    LOAD_USER_PROMOCODES
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_USER_PROMOCODES:
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/loyalty/LoyaltyUserCodesReducer.js